import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const Header1 = () => {
  const navigate = useNavigate();
  const headerLogo = useSelector((state) => state?.userData?.header_logo);
  const headerName = useSelector((state) => state?.userData?.header_name);
  return (
    <>
      <header id="app_Mainheader" className="app_header">
        <button className="Close_menu_overlay">close</button>
        <div className="HeaderSearch_backdrop" onclick="SearchClose()" />
        <div className="container-fluid h-100 p-0 ">
          <div className="d-flex align-items-center h-100 justify-content-between app_Mainheader_content justify-content-center">
            <div className="d-inline-flex justify-content-center mx-auto">
              <div className="Applogo_col cursor-pointer d-inline-flex align-items-center justify-content-center mx-auto">
                <a
                  className=" d-inline-flex align-items-center position-relative z-2 pe-1"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  {" "}
                  <img src={headerLogo} />
                  <span className="font-18px font-bold ps-3 text-default UniversityName line-height-110">
                    {headerName}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
export default Header1;
